/* eslint-disable react/no-unused-state */
import React from 'react';
import { Result, Button } from 'antd';

/**
 * Error Boundary component to catch React errors and display user-friendly error messages
 * Prevents the entire app from crashing when an error occurs
 */
class ErrorBoundary extends React.Component {
  constructor(props) {
    super(props);
    this.state = { 
      hasError: false, 
      error: null, 
      errorInfo: null 
    };
  }
  
  static getDerivedStateFromError(error) {
    // Update state so the next render will show the fallback UI
    return { hasError: true };
  }
  
  componentDidCatch(error, errorInfo) {
    // Log error to error reporting service
    console.error('ErrorBoundary caught an error:', error, errorInfo);
    this.setState({ 
      error, 
      errorInfo 
    });
    
    // TODO: Send to error tracking service (e.g., Sentry, LogRocket)
    // Example:
    // if (window.Sentry) {
    //   window.Sentry.captureException(error, { contexts: { react: errorInfo } });
    // }
  }
  
  handleReload = () => {
    window.location.reload();
  };
  
  handleReset = () => {
    this.setState({ 
      hasError: false, 
      error: null, 
      errorInfo: null 
    });
  };
  
  render() {
    if (this.state.hasError) {
      // Custom error UI
      return (
        <Result
          status="500"
          title="500"
          subTitle="Sorry, something went wrong. Please try reloading the page."
          extra={[
            <Button type="primary" key="reload" onClick={this.handleReload}>
              Reload Page
            </Button>,
            <Button key="reset" onClick={this.handleReset}>
              Try Again
            </Button>
          ]}
        />
      );
    }
    
    return this.props.children;
  }
}

export default ErrorBoundary;
